import boy1 from './boy-1.svg'
import boy2 from './boy-2.svg'
import boy3 from './boy-3.svg'
import boy4 from './boy-4.svg'
import boy5 from './boy-5.svg'
import boy6 from './boy-6.svg'
import boy7 from './boy-7.svg'
import boy8 from './boy-8.svg'
import boy9 from './boy-9.svg'
import boy10 from './boy-10.svg'
import boy11 from './boy-11.svg'
import boy12 from './boy-12.svg'
import boy13 from './boy-13.svg'
import boy14 from './boy-14.svg'
import boy15 from './boy-15.svg'
import boy16 from './boy-16.svg'
import boy17 from './boy-17.svg'
import boy18 from './boy-18.svg'
import boy19 from './boy-19.svg'
import boy20 from './boy-20.svg'
import boy21 from './boy-21.svg'
import boy22 from './boy-22.svg'
import boy23 from './boy-23.svg'
import boy24 from './boy-24.svg'
import girl1 from './girl-1.svg'
import girl2 from './girl-2.svg'
import girl3 from './girl-3.svg'
import girl4 from './girl-4.svg'
import girl5 from './girl-5.svg'
import girl6 from './girl-6.svg'
import girl7 from './girl-7.svg'
import girl8 from './girl-8.svg'
import girl9 from './girl-9.svg'
import girl10 from './girl-10.svg'
import girl11 from './girl-11.svg'
import girl12 from './girl-12.svg'
import girl13 from './girl-13.svg'
import girl14 from './girl-14.svg'
import girl15 from './girl-15.svg'
import girl16 from './girl-16.svg'
import girl17 from './girl-17.svg'
import girl18 from './girl-18.svg'
import girl19 from './girl-19.svg'
import girl20 from './girl-20.svg'
import girl21 from './girl-21.svg'
import girl22 from './girl-22.svg'
import girl23 from './girl-23.svg'
import girl24 from './girl-24.svg'
import girl25 from './girl-25.svg'
import girl26 from './girl-26.svg'

export default {
  boy1,
  boy2,
  boy3,
  boy4,
  boy5,
  boy6,
  boy7,
  boy8,
  boy9,
  boy10,
  boy11,
  boy12,
  boy13,
  boy14,
  boy15,
  boy16,
  boy17,
  boy18,
  boy19,
  boy20,
  boy21,
  boy22,
  boy23,
  boy24,
  girl1,
  girl2,
  girl3,
  girl4,
  girl5,
  girl6,
  girl7,
  girl8,
  girl9,
  girl10,
  girl11,
  girl12,
  girl13,
  girl14,
  girl15,
  girl16,
  girl17,
  girl18,
  girl19,
  girl20,
  girl21,
  girl22,
  girl23,
  girl24,
  girl25,
  girl26,
}
